<template>
    <section id="dimmed-bg">

            <div id="popup-container">
                <div class="popup-text" v-html='message'>
                </div>
                <div id="check-button">
                    <input class="red-btn-popup btn" type="button" :value="l10.FindPassword_Ok_Popup_Button1" v-on:click='$emit("message", "")'>
                </div>
            </div>

        </section>
</template>
<script>
export default {
    props: ['message'],
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang] ? text[this.$store.state.lang] : text['cn'];
        const lang = this.$store.state.lang;
	    return {
            l10:l10n,
            changedLanguage:lang,
            lang:lang,
        }
    }
}
</script>

<style src="@/assets/coupon/popup.css" scoped></style>
<style scoped>
@media (max-width: 720px) {
    input {-webkit-appearance: none;-moz-appearance: none;appearance: none;}
}
</style>